// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgAuthIllustration = ({
  color = 'currentColor',
  size = 20
}: IconProps) => (
  <svg
    viewBox="0 0 30 32"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      d="M9.442 11.162c.28-.772.85-1.405 1.588-1.764l6.32-3.073a3.158 3.158 0 0 1 4.26 1.544l2.883 6.409c.337.748.369 1.6.09 2.371l-3.976 10.968a3.158 3.158 0 0 1-4.045 1.893L7.36 26.174a3.158 3.158 0 0 1-1.893-4.045l3.975-10.967Z"
      fill="#E1CEFF"
    />
    <path
      d="M9.81 10.254c.28-.772.849-1.404 1.587-1.764l6.32-3.073a3.158 3.158 0 0 1 4.26 1.545l2.884 6.408c.337.749.369 1.6.089 2.372l-3.975 10.967a3.158 3.158 0 0 1-4.045 1.893l-9.203-3.335a3.158 3.158 0 0 1-1.892-4.045L9.81 10.254Z"
      fill="#7528D5"
    />
    <path
      d="m10.476 8.23 2.449.53-2.117 1.342-.529 2.449-1.342-2.117-2.45-.53 2.117-1.341.531-2.45 1.34 2.117Z"
      fill="#FFC103"
    />
    <path
      d="M18.978 10.636a1.998 1.998 0 1 0-.7-3.934 1.998 1.998 0 0 0 .7 3.934Z"
      fill="#E1CEFF"
    />
    <path
      d="M18.849 9.922a1.272 1.272 0 1 0-.445-2.504 1.272 1.272 0 0 0 .445 2.504ZM15.333 16.036a.816.816 0 1 0-1.414-.815.816.816 0 0 0 1.414.815Zm.604.348a1.513 1.513 0 1 1-2.622-1.513 1.513 1.513 0 0 1 2.622 1.513ZM18.033 21.702a.816.816 0 1 0-1.414-.815.816.816 0 0 0 1.414.815Zm.604.349a1.514 1.514 0 1 1-2.622-1.514 1.514 1.514 0 0 1 2.622 1.514ZM18.69 14.882a.419.419 0 0 1 .617.566L13.26 22.04a.419.419 0 1 1-.616-.566l6.046-6.592Z"
      fill="#F8F5FF"
    />
  </svg>
)

export default SvgAuthIllustration
